export default __webpack_public_path__ + "static/media/primec++.db2aaf0b.jpg";